import React, { useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { apiError } from '../utils/format';
import { BRAND } from '../utils/brand';

const Login = () => {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  // Where the guard sent them from, so an expired session resumes where it
  // ended rather than dropping everyone on the dashboard.
  const from = location.state?.from?.pathname
    ? `${location.state.from.pathname}${location.state.from.search || ''}`
    : '/';

  // Redirecting during render is what <Navigate> is for; calling navigate()
  // here warned and could run twice.
  if (user) return <Navigate to={from} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError('');
    try {
      await login(email.trim(), password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(apiError(err, 'Login failed'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-page">
      <aside className="login-brandside">
        <img src={BRAND.logo} className="login-logo" alt={BRAND.name} />
        <p className="login-brand-name">{BRAND.name}</p>
        <p className="login-brand-tag">
          {BRAND.tagline.map((part, i) => (
            <React.Fragment key={part}>{i > 0 && <span className="brand-dot">•</span>}{part}</React.Fragment>
          ))}
        </p>
        <p className="login-brand-since">{BRAND.system} · {BRAND.since}</p>
        <p className="login-brand-sub">Inventory, production, packing, suppliers, payroll and point&nbsp;of&nbsp;sale — one system for every branch.</p>
      </aside>

      <main className="login-formside">
        <form className="login-card" onSubmit={submit}>
          <img src={BRAND.logo} className="login-logo-sm" alt={BRAND.name} />
          <h1 className="login-title">Welcome back<span className="login-title-accent" /></h1>
          <p className="login-sub">Sign in to {BRAND.systemName}</p>
          <div className="field">
            <label>Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus placeholder="you@avakaayafoods.com" />
          </div>
          <div className="field">
            <label>Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="••••••••" />
          </div>
          {error && <p className="form-error">{error}</p>}
          <button className="btn btn-primary btn-block" disabled={busy} style={{ marginTop: '.4rem' }}>
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
        <p className="login-foot">© {new Date().getFullYear()} {BRAND.name} · All rights reserved</p>
      </main>
    </div>
  );
};

export default Login;
